import { render, staticRenderFns } from "./transaksi.vue?vue&type=template&id=a6e5f98e&"
import script from "./transaksi.vue?vue&type=script&lang=js&"
export * from "./transaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports